<div class="product">
  <div class="product__image">
    <img
      class="product__image_img"
      loading="lazy"
      onerror="onerror=null;src='assets/images/image-placeholder.svg';"
      [src]="image()"
      [alt]="name()"
    />
  </div>

  <div class="product__content">
    <h5 class="product__content_name" [innerHTML]="name()"></h5>

    @if (addOns().length > 0) {
      <div class="product__content_add-ons add-ons">
        <ul class="add-ons__list">
          @for (addOn of groupedAddOns() | keyvalue; track $index) {
            <li class="add-ons__list-item add-on">
              <h6 class="add-on__title" [innerHtml]="addOn.key"></h6>

              <ul class="add-on__options">
                @for (addOnValue of addOn.value; track $index) {
                  <li class="add-on__options-item option">
                    <span class="option__name" [innerHtml]="addOnValue.value"></span>
                    @if (addOnValue.price != 0) {
                      <span class="option__price">
                        +{{ addOnValue.price | formattedCurrency: 0 }}
                      </span>
                    }
                  </li>
                }
              </ul>
            </li>
          }
        </ul>
      </div>
    }

    <div class="product__content_price">
      <span class="product__content_price_label">
        {{ price() | formattedCurrency: cartMinorUnit() }}
      </span>

      <div class="product__content_price_counter">
        <app-counter
          [removable]="true"
          [style]="CounterStyle.Primary"
          [disabled]="isDisabled()"
          [min]="minQuantity()"
          [max]="maxQuantity()"
          [(ngModel)]="quantity"
          (remove)="onRemove()"
          (ngModelChange)="onUpdate($event)"
        />
      </div>
    </div>
  </div>
</div>
